"use client";

import dynamic from "next/dynamic";

import { FormWrapper } from "@/components/custom/form-helpers/form-wrapper";
import { AgoraBug } from "@/components/custom/svgs/agora-bug";

const DescopeLoginFlow = dynamic(() => import("../components/descope-login-flow"), { ssr: false });

export function DescopeLoginView() {
  return (
    <div className="mx-auto w-full rounded-lg shadow-lg">
      <FormWrapper>
        <div className="px-3 py-4 lg:px-6 lg:py-8">
          <div className="mb-8 flex items-center justify-center">
            <AgoraBug height={36} />
          </div>

          <DescopeLoginFlow />
        </div>
      </FormWrapper>
    </div>
  );
}
